import Swiper from "swiper";
import Animate from "../components/animate";

interface SliderOptions {
    /**
     * Enable on width (px)
     *
     * @default 567
     */
    enableBreakpointDown?: number;

    /**
     * Mobile-container fix (px)
     *
     * @default 0
     * */
    container?: number;

    /**
     * Space between (px)
     *
     * @default 0
     * */
    spaceBetween?: number;

    /**
     * on init
     *
     * */
    onInit?: (freeMode: OverflowSlider) => any;

    /**
     * on slide change transition end
     *
     * */
    slideChangeTransitionEnd?: (freeMode: OverflowSlider) => any;

    autoplay?: boolean;

    freeMode?: boolean;

    /**
     * Возврат к следующему слайду
     * */
    stepByStep?: boolean;

    /**
     * Прокрутка до ближайшего шага после того, как слайдер остановился
     * */
    magnet?: boolean;

    /**
     * Жесткая остановка на шаге
     * */
    stopOnStep?: boolean;
}

const SliderDefaultOptions: SliderOptions = {
    enableBreakpointDown: 567,
    autoplay: false,
    container: 0,
    spaceBetween: 0,
    stepByStep: true,
    magnet: true,
    stopOnStep: true,
    onInit: null,
    slideChangeTransitionEnd: null,
    freeMode: false
}

class OverflowSlider {
    protected swiper;
    protected options;
    protected observer;
    protected currentScroll = 0;
    protected slideFullWidth = 0;
    protected timer: NodeJS.Timeout;
    protected playTimer: NodeJS.Timeout;
    protected wrapper = null;
    protected itemWidth = 0;
    protected isAnimate = false;
    protected isScrolling = false;
    protected onTouchMove = false;
    protected readonly direction = {left: 1, right: -1};
    public slides = null;
    public activeIndex = 1;

    constructor(swiper: Swiper, options: SliderOptions) {
        this.swiper = swiper;
        this.options = {...SliderDefaultOptions, ...options};
        this.slides = this.swiper.slides;
        this.wrapper = this.swiper.wrapperEl;
        this.checkFreeMode();
        window.addEventListener('resize', this.checkFreeMode.bind(this));
    }

    appendSlide(slides) {
        Array.from(slides).forEach((slide: HTMLElement) => {
            this.swiper.slides.push(slide);
            this.wrapper.append(slide)
            slide.dataset.index = String(this.swiper.slides.length);
            this.observer.observe(slide);
        })
        this.slides = this.swiper.slides;
    }

    play() {
        let nextIndex = (this.swiper.slides.length >= this.activeIndex + 1) ? this.activeIndex + 1 : 1;
        this.playTimer = setTimeout(() => {
            this.slideTo(nextIndex, 300)
        }, 4500)
    }

    bindEvents() {

        if (!this.options.freeMode) {
            this.wrapper.addEventListener('touchstart', () => {
                this.onTouchMove = true;
                if (this.options.autoplay) {
                    clearTimeout(this.playTimer)
                }
            });
            this.wrapper.addEventListener('touchend', () => {
                this.onTouchMove = false;
                if (!this.isScrolling) {
                    // если остановились не на точке
                    if (this.positionByIndex(this.activeIndex) !== this.wrapper.scrollLeft) {
                        this.goToNearest()
                    }
                }
            });
            this.wrapper.addEventListener('scroll', this.goToNearest.bind(this))
        }
    }

    protected init() {
        this.bindEvents();
        this.swiper.destroy(false, true);
        this.swiper.el.classList.add('free-mode')
        this.swiper.el.style = '--item-margin: 0 ' + this.options.spaceBetween + 'px';
        this.initObserver();

        this.slides.forEach((e: HTMLElement, i: number) => {
            e.dataset.index = String(i + 1);
            this.observer.observe(e);
        });

        this.slideTo(1, 1);

        if (this.options.onInit !== null)
            this.options.onInit(this);
    }

    protected goToNearest() {
        this.isScrolling = true;
        this.currentScroll = this.wrapper.scrollLeft;

        if (this.options.stepByStep) {
            let diff = this.getActiveIndexByScroll() - this.activeIndex;
            if (!this.isAnimate && !this.onTouchMove) {
                if (Math.abs(diff) > 1) {
                    this.slideTo(this.activeIndex + Math.sign(diff), 200)
                }
            }
        }

        clearTimeout(this.timer);
        /*if (!this.onTouchMove) {
            this.slideTo(index, 300)
        }*/
        this.timer = setTimeout(() => {
            this.isScrolling = false;

            if (this.options.magnet) {
                if (!this.isAnimate && !this.onTouchMove) {
                    if (this.positionByIndex(this.activeIndex) !== this.currentScroll) {
                        this.slideTo(this.getActiveIndexByScroll(), 100)
                    }
                }
            }
        }, 50);
    }

    protected getActiveIndexByScroll() {
        return Math.round(this.currentScroll / this.slideFullWidth) + 1;
    }

    protected destroy() {
        this.swiper.init();
        this.swiper.destroyed = false;
        this.swiper.el.classList.remove('free-mode')
    }

    /**
     * Определение позиции слайда по индексу
     * */
    public positionByIndex(index) {
        let sliderLength = this.slides.length;
        let spaceBetween = this.options.spaceBetween;
        let sliderWidth = (sliderLength * this.itemWidth) + ((sliderLength * spaceBetween) * 2)
        this.slideFullWidth = sliderWidth / sliderLength;

        return (this.slideFullWidth * (index - 1)) + (spaceBetween - this.options.container);
    }

    /**
     * Магнит слайдов при скролле
     * todo мб делать на EventListener ?
     * */
   protected initObserver() {
        let spacing = String(this.options.spaceBetween - this.options.container);
        let options = {
            root: this.wrapper,
            rootMargin: "40% ".concat(spacing, "px"),
            threshold: [1]
        }

        this.observer = new IntersectionObserver((entry) => {
            if (entry[0].intersectionRatio === 1 && entry[0].target instanceof HTMLElement) {
                let index = Number(entry[0].target.dataset.index);

                if (this.activeIndex !== index && !this.isAnimate) {
                    if (this.options.stopOnStep) {
                        this.wrapper.scrollLeft = this.positionByIndex(index);
                        this.slideTo(index, 100)
                    }
                }
            }
        }, options)

    }

    inOutQuad(n){
        n *= 2;
        if (n < 1) return 0.5 * n * n;
        return - 0.5 * (--n * (n - 2) - 1);
    };

    /**
     * Run transition to the slide with index number equal to 'index' parameter for the
     *  duration equal to 'speed' parameter.
     *
     * @param index Index number of slide.
     * @param speed Transition duration (in ms).
     * */
    public slideTo(index, speed = 1) {
        if (this.wrapper && this.itemWidth) {
            let finalPosition = this.positionByIndex(index);
            let currentPosition = this.wrapper.scrollLeft;
            let diff = currentPosition - finalPosition;

            this.slideChangeTransitionStart();
            new Animate({
                duration: speed,
                draw: timeFraction => {
                    //console.log(timeFraction)
                    /*let x = 1.4;
                    let fn = Math.pow(timeFraction, 2) * ((x + 1) * timeFraction - x) ;
                    fn = fn >= 1 ? 1 : fn;
                    console.log(fn)*/
                    this.wrapper.scrollLeft = currentPosition - (diff * timeFraction);
                  //  console.log(diff * easing(timeFraction), easing(timeFraction))
                },
                onEnd: () => {
                    this.slideChangeTransitionEnd(index);
                }
            });
        }
    }

    protected slideChangeTransitionStart() {
        this.isAnimate = true;
        this.wrapper.classList.add('overflow-hidden')
        this.slides.forEach((e: HTMLElement) => {
            e.classList.remove('swiper-slide-active');
        });
    }

    protected slideChangeTransitionEnd(index) {
        this.activeIndex = index;
        this.swiper.activeIndex = index;
        this.isAnimate = false
        this.wrapper.classList.remove('overflow-hidden')
        let slide = this.wrapper.querySelector('[data-index="' + this.activeIndex + '"]')
        slide.classList.add('swiper-slide-active');

        if (this.options.autoplay) {
            clearTimeout(this.playTimer)
            this.play()
        }

        if (this.options.slideChangeTransitionEnd !== null)
            this.options.slideChangeTransitionEnd(this);
    }

    protected checkFreeMode() {
        this.itemWidth = this.slides[0].offsetWidth;
        if (window.innerWidth < this.options.enableBreakpointDown) {
            if (!this.swiper.destroyed)
                this.init()
        } else {
            if (this.swiper.destroyed)
                this.destroy()
        }
    }
}


export default OverflowSlider;
